import { Component } from 'react';
import { withRouter } from 'react-router-dom';

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

// ※withRouterを使用することで毎回各画面コンポーネントのライフサイクルメソッドが動くので重要
export default withRouter(ScrollToTop);
